import { CheckCircle2, FolderPlus, PencilLine, PlusCircle, XCircle } from "lucide-react";

import { Mudanca, Numero, Secao } from "../fiscal/components/PreviaPlanilha";
import { medidaDoProduto } from "../../lib/unidadeVenda";
import EscolherCategorias from "./EscolherCategorias";

const reais = (n) => Number(n || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

// Unidade de venda do produto novo (30/09/2026): o servidor manda `unidade`
// ("un"/"kg"/"L") e `fracionado`. Por peso = kg/L + fracionado (lib/unidadeVenda).
const NOME_UNIDADE = { kg: "quilo", L: "litro" };
function unidadeDoNovo(n) {
  const medida = medidaDoProduto({ sale_unit: n.unidade, is_divisible: n.fracionado });
  if (medida) return { medida, texto: `por ${NOME_UNIDADE[medida]}` };
  const un = String(n.unidade || "un");
  const nome = NOME_UNIDADE[un] || NOME_UNIDADE[un.toUpperCase()];
  return { medida: null, texto: nome ? `${nome}, vendido inteiro` : "por unidade" };
}

function Novo({ n, escolhida }) {
  const categoria = n.categoria || escolhida;
  const unidade = unidadeDoNovo(n);
  return (
    <div className="px-4 py-2.5 text-xs flex justify-between gap-3">
      <div className="min-w-0">
        <div className="text-sm font-medium truncate">{n.nome}</div>
        <div className="text-muted-foreground">
          {categoria || <span className="text-amber-600 font-medium">Sem categoria — escolha acima</span>}
          {n.categoria_nova && <span className="ml-1.5 text-amber-600 font-medium">· categoria nova</span>}
          <span> · {unidade.texto}</span>
          {n.codigo_digitado && <span> · código {n.codigo_digitado} não existe, o sistema gera outro</span>}
        </div>
      </div>
      <span className="font-semibold text-emerald-600 dark:text-emerald-400 shrink-0">
        {reais(n.preco)}{unidade.medida && `/${unidade.medida}`}
      </span>
    </div>
  );
}

/** Prévia da importação da planilha de Produtos. Só leitura — quem confirma é o diálogo. */
export default function PreviaCardapio({ previa, escolhas = {}, onEscolher, onEscolherTodos }) {
  const r = previa.resumo;
  const semCategoria = previa.novos.filter((n) => n.sem_categoria);
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <Numero icone={PencilLine} valor={r.atualizar} rotulo="Vão mudar" cor="text-primary" />
        <Numero icone={PlusCircle} valor={r.novos} rotulo="Produtos novos" cor="text-emerald-600" />
        <Numero icone={CheckCircle2} valor={r.sem_mudanca} rotulo="Já estavam iguais" cor="text-muted-foreground" />
        <Numero icone={XCircle} valor={r.erros} rotulo="Com erro" cor="text-red-600" />
      </div>

      <EscolherCategorias
        produtos={semCategoria}
        opcoes={previa.categorias_disponiveis || []}
        escolhas={escolhas}
        onEscolher={onEscolher}
        onEscolherTodos={onEscolherTodos}
      />

      {previa.categorias_novas?.length > 0 && (
        <div className="flex gap-2 rounded-xl border border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-800 px-3 py-2.5 text-xs">
          <FolderPlus className="w-4 h-4 text-amber-600 shrink-0" />
          <span>
            {previa.categorias_novas.length === 1 ? "Categoria nova vai ser criada: " : "Categorias novas vão ser criadas: "}
            <strong>{previa.categorias_novas.join(", ")}</strong>. Confira se não é erro de digitação.
          </span>
        </div>
      )}

      <Secao titulo="O que vai mudar" total={r.atualizar} aberta>
        {previa.mudancas.map((m) => <Mudanca key={m.produto_id} m={m} />)}
      </Secao>

      <Secao titulo="Produtos novos" total={r.novos} aberta={r.atualizar === 0}>
        {previa.novos.map((n) => <Novo key={n.linha} n={n} escolhida={escolhas[n.linha]} />)}
      </Secao>

      <Secao titulo="Linhas com erro — não serão gravadas" total={r.erros} aberta={!r.atualizar && !r.novos}>
        {previa.erros.map((e, i) => (
          <div key={`${e.linha}-${i}`} className="px-4 py-2 text-xs">
            <span className="font-medium">Linha {e.linha} · {e.produto || "sem nome"}</span>
            <div className="text-red-600 dark:text-red-400 mt-0.5">{e.mensagem}</div>
          </div>
        ))}
      </Secao>
    </div>
  );
}
